import React from "react"
import {
  createStyles,
  forwardRef,
  HTMLStyledProps,
  styled,
} from "@design-system/core"
import { __DEV__ } from "@design-system/utils"
import { useModalContext } from "./ModalContext"

export interface ModalBodyProps extends HTMLStyledProps<"div"> {}

const styles = createStyles((theme) => ({
  body: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "0%",
    paddingHorizontal: theme.spaces.spacing32,
    paddingVertical: theme.spaces.spacing8,
    fontSize: theme.fontSizes.large,
    lineHeight: theme.lineHeights.large,
  },
  widthSmall: {
    paddingHorizontal: theme.spaces.spacing16,
    fontSize: theme.fontSizes.medium,
    lineHeight: theme.lineHeights.medium,
  },
  scroll: {
    overflow: "auto",
  },
}))

export const ModalBody = forwardRef<ModalBodyProps, "div">((props, ref) => {
  const { style, ...others } = props
  const { scrollBehavior, widthSmall } = useModalContext()
  return (
    <styled.div
      {...others}
      style={[
        styles.body,
        widthSmall && styles.widthSmall,
        scrollBehavior === "body" && styles.scroll,
        style,
      ]}
      ref={ref}
    />
  )
})

if (__DEV__) {
  ModalBody.displayName = "ModalBody"
}
